function formatterCalculatorHtml2(text: string, name: string): string | null {
  const regex2 = /https:\/\/web.gpmed.app\/calculadoras\/(\w+)/;
  const result = regex2.exec(text);
  if (!result) {
    return null;
  }
  const sku = result[1];
  return `<span href="/calculadoras/${sku}" target="_parent" style="text-decoration: underline; color: #593ABC; font-weight: bold;">${name}</span>`;
}
export default formatterCalculatorHtml2;
